import { ChangeDetectorRef, Component, Input, Inject } from "@angular/core";
import * as GoldenLayout from "golden-layout";
import * as _ from "underscore";

import {
  GoldenLayoutComponentState,
  GoldenLayoutContainer,
} from "golden-layout/golden-layout.directive";
import { AfterViewChecked } from "@angular/core";
import { GoldenLayoutService } from "@app/services/golden-layout.service";
import { BASE_COMPONENT_KEY } from "@app/components/editor/workspace/golden-layout-definitions";

@Component({
  template: `
    <div
      class="page-cell page-cell-text"
      style="width: 100%; height: 100%"
      [style.padding]="state.style.padding"
      [style.background-color]="state.style['background-color']"
      (click)="onClick()"
    ></div>
  `,
})
export class GoldenLayoutBaseComponent implements AfterViewChecked {
  protected oldState: any;

  constructor(
    @Inject(GoldenLayoutComponentState) protected state: any,
    @Inject(GoldenLayoutContainer) protected container: GoldenLayout.Container,
    protected goldenLayoutService: GoldenLayoutService,
    protected cdRef: ChangeDetectorRef
  ) {
    this.state.title = "drag";
    this.state.style = this.state.style || {};
    this.state.style.padding = this.state.style.padding || 0;
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
  ngDoCheck() {
    if (!_.isEqual(this.oldState, this.state)) {
      this.container.extendState(this.state);
    }
    this.oldState = JSON.parse(JSON.stringify(this.state));
  }
  onClick() {
    this.select(BASE_COMPONENT_KEY);
  }
  select(type: string) {
    this.goldenLayoutService.updateSelection({ type: type, state: this.state });
  }
}
